import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Http from 'services/http2';
import KpiFns from '../functions/kpi';
import ModalService from 'services/modal';
import ReactEcharts from 'echarts-for-react';
import dayjs from 'dayjs';
import CardContent from '@material-ui/core/CardContent';
import Util from 'lib/util.js';
import SupplierService from 'services/supplier';
function SupplierTerminateDetail(props) {
  const Config = {
    purchase: {
      title: '供应商清退详情',
      apiPath: '/eliminate/vendor/notice/detail',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_eliminate_vendor_notice_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'elXkNo',
      wfmCode: '1021'
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [radarOpts, setRadarOpts] = useState({});

  //处理详情数据
  self.afterGetDetail = function (data) {
    radarGbVendor(data);
    setDetail(data);
  };

  //供应商绩效等级雷达图
  function radarGbVendor(detailData) {
    let months = [];
    let n = 12;
    for (let i = 0; i < n; i += 1) {
      let d = dayjs().subtract(i, 'month');
      let year = d.year();
      let month = d.month() + 1;
      let m = month > 9 ? month : '0' + month;
      months.push(String(year) + m);
    }
    let postbody = {
      companyCode: companyCode,
      monthStart: months[months.length - 1],
      monthEnd: months[0],
      companyCodes: [detailData.vendorCode],
      apiPath: '/assessment/comp/score/radarGbComp'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        let radarOpt = {};
        for (var key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key) === true) {
            data[key].forEach(item => (item.score = item.score.toFixed(2)));
            radarOpt[key] = KpiFns.genCompareRadarOpt(data[key]);
          }
        }
        setRadarOpts(radarOpt);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  /** 采购方操作 begin **/

  //发布
  function publish() {
    let postbody = {
      companyCode: companyCode,
      elXkNo: self.id,
      apiPath: '/eliminate/vendor/notice/publish'
    };
    SupplierService.publishPenaltyNotice(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  /** 采购方操作 end **/

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">通知单号</span>
                  <div className="field-value">{detail.elInnerNo}</div>
                </li>
                <li>
                  <span className="field-label">供应商类型</span>
                  <div className="field-value">
                    {detail.vendorType === 1 ? '正式供应商' : '潜在供应商'}
                  </div>
                </li>
                <li>
                  <span className="field-label">供应商</span>
                  <div className="field-value">
                    {detail.innerVendorName} - {detail.innerVendorCode}
                  </div>
                </li>
                <li>
                  <span className="field-label">退出类型</span>
                  <div className="field-value">
                    {detail.exitType === 1 ? '供应商退出 ' : '品类退出'}
                  </div>
                </li>
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          'B02_eliminate_vendor_notice_Status',
                          detail.status
                        )
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>清退处理</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">未完成订单</span>
                  <div className="field-value">
                    {detail.unfinishedPurOrderOperateType === 1
                      ? '继续完成'
                      : '停止执行'}
                  </div>
                </li>
                <li>
                  <span className="field-label">加入黑名单</span>
                  <div className="field-value">
                    {detail.blackListFlag === 0
                      ? '否 '
                      : '是（后续不再允许交易）'}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>清退说明</label>
          </div>
          <div className="details-item-content">
            <div className="content-line line-list-item">
              <ul className="field-list">
                <li>
                  <span className="field-label">清退说明</span>
                  <div className="field-value">{detail.eliminateDesc}</div>
                </li>
              </ul>
            </div>
            <div className="content-line line-list-item">
              <ul className="field-list">
                <li>
                  <span className="field-label">历史处罚单</span>
                  <div className="field-value">{detail.punishOrderCount}</div>
                </li>
                <li>
                  <span className="field-label">未完结订单</span>
                  <div className="field-value">
                    {detail.unfinishedPurOrderCount}
                  </div>
                </li>
                <li>
                  <span className="field-label">未完结送货</span>
                  <div className="field-value">
                    {detail.unfinishedDeliveryNoticeCount}
                  </div>
                </li>
              </ul>
            </div>
            <div className="content-line line-list-item">
              <CardContent style={{ padding: '20px' }} className="chartRadar">
                {!Util.isEmpty(radarOpts) && (
                  <ReactEcharts
                    option={radarOpts[detail.vendorCode]}
                    notMerge={true}
                    lazyUpdate={true}
                  />
                )}
              </CardContent>
            </div>
          </div>
        </div>
      </div>

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {[0, 2].includes(detail.status) &&
            workflow?.data?.eliminate_vendor_publish_1.complete && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布
              </Button>
            )}
        </div>
      )}
      <Modal></Modal>
    </div>
  );
}

SupplierTerminateDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupplierTerminateDetail);
